export const config = { defaultURL: "https://db.thermalimagingcenter.com/api" };

/*
const isDev = window.location.hostname === 'localhost' || 
              window.location.hostname === '127.0.0.1';

export const config = {
  defaultURL: isDev 
    ? "http://localhost:3000/api"
    : "http://api.thermalimagingcenter.com/api"
};
*/